export default __webpack_public_path__ + "static/media/allow-withdraw-1-android.808dab85.png";